/**
 * 差し戻し理由入力画面の値を管理するクラス
 *
 * @export KYMW1706Model
 * @class KYMW1706Model
 */
export class KYMW1706Model {
  public guideGoodsName: string = <string>'';
  public guideStandardName: string = <string>'';
  public imageFileName:string = <string>'';
  public remandReson: string = <string>'';
}
